import {CELL_REGEX} from '../regex'

export default function cellValidator(value){
  const result = CELL_REGEX.test(value)
  return result
}
